module.exports = __webpack_public_path__ + "static/media/tiktok.d4863855.svg";